import React, { useEffect } from "react";

import { IgSelect, IgTypography } from "@intelligems/ig-theme";
import { DeviceType, TrafficConfigFilterType } from "@intelligems/ig-types";
import { Grid, MenuItem } from "@mui/material";
import { deviceTypeList } from "@src/components/AudienceFilters/utils";

interface DeviceSelectProps {
  onChange: (value: string, changeKey: "key" | "filter" | "value") => void;
  deviceType: DeviceType;
}

export const DeviceSelect = ({ onChange, deviceType }: DeviceSelectProps) => {
  // handle when type switched and value not compatible
  useEffect(() => {
    if (!deviceTypeList.find((device) => device.key === deviceType))
      onChange(deviceTypeList[1].key, "value");
  }, []);

  return (
    <Grid item>
      <IgSelect
        variant={"outlined"}
        key={`device-type`}
        value={deviceType || deviceTypeList[1].key}
        onChange={(e) => {
          onChange(e.target.value as TrafficConfigFilterType, "value");
        }}
      >
        {deviceTypeList
          .filter((device) => device.key !== "any")
          .map((device) => (
            <MenuItem key={`${device.key}`} value={device.key}>
              <Grid container direction={"column"}>
                <Grid item>
                  <IgTypography>{device.label}</IgTypography>
                </Grid>
              </Grid>
            </MenuItem>
          ))}
      </IgSelect>
    </Grid>
  );
};
